module.exports = __webpack_public_path__ + "static/media/car6.d75ee2a5.jpg";